<template>
    <div>
        <NavBar></NavBar>
        <div class="row align-items-center">
            <div class="col-12 col-sm-4">
                <RawMatArea @lengthChanged="getLengthChange" @widthChanged="getWidthChange"></RawMatArea>
            </div>
            <div class="col-12 col-sm-8">
                <RawMatSpecification @sendSheetTypeId="getsheetTypeId" @sendKiloPrice="getSheetKiloPrice"
                    :getLength="lengthValue" :getWidth="widthValue" @sendWeight="getWeigthValue"
                    @sendPriceConstant="getPriceConstant" @sendCommercialMm="getCommercialMm"></RawMatSpecification>
            </div>
        </div>
        <ServicesNoImgQuote :getMainSheetType="sheetTypeId" :getWeight="weigthValue"
            @sendTotalServices="getTotalServices">
        </ServicesNoImgQuote>
        <SheetPrice :getKiloPrice="sheetKiloPrice" :getWeightUnit="weigthValue" :getFinalServicesPrice="priceServices"
            :getLengthValue="lengthValue" :getWidthValue="widthValue" :getPriceConstant="priceConstant"
            :getCommercialMm="commercialMm"></SheetPrice>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import RawMatArea from "@/components/SheetQuote/RawMaterialAreaComponent.vue";
import RawMatSpecification from "@/components/SheetQuote/RawMaterialSpecificationComponent.vue";
import ServicesNoImgQuote from "@/components/SheetQuote/ServicesSheetNoImgQuoteComponent.vue";
import SheetPrice from "@/components/SheetQuote/SheetPriceComponent.vue";
export default {
    components: {
        NavBar,
        RawMatArea,
        RawMatSpecification,
        ServicesNoImgQuote,
        SheetPrice,
    },
    data() {
        return {
            lengthValue: 0,
            widthValue: 0,
            sheetTypeId: 0,
            sheetKiloPrice: 0,
            weigthValue: 0,
            priceConstant: 0,
            commercialMm: 0,
            //Servicios
            priceServices: 0,
        };
    },
    methods: {
        getLengthChange(data) {
            this.lengthValue = data;
            // console.log("Desde la vista length", this.lengthValue);
        },
        getWidthChange(data) {
            this.widthValue = data;
            // console.log("Desde la vista width", this.widthValue);
        },
        getWeigthValue(data) {
            this.weigthValue = data;
            // console.log("Desde la vista weigth", this.weigthValue);
        },
        getsheetTypeId(data) {
            //Recibir parametros del emit de un hijo a el padre
            this.sheetTypeId = data;
            // console.log("Desde la vista sheetTypeId", this.sheetTypeId);
        },
        getSheetKiloPrice(data) {
            this.sheetKiloPrice = data;
            //console.log("Desde la vista kiloP", this.sheetKiloPrice);
        },
        getServicesPrice(data) {
            this.priceServices = data;
            // console.log("Desde la vista servicios", this.priceServices);
        },
        getPriceConstant(data) {
            this.priceConstant = data;
            // console.log("Desde la vista priceConst", this.priceConstant);
        },
        getCommercialMm(data) {
            this.commercialMm = data;
            // console.log("Desde la vista commercialMm", this.commercialMm);
        },
        getTotalServices(data) {
            this.priceServices = data;
            // console.log("Servicios desde la vista", this.priceServices);
        }
    },
};
</script>
<style scoped></style>